import React from "react";
import { useNavigate } from "react-router-dom";

function GetCode() {
  const navigate = useNavigate();

  // این کامپوننت فعلاً استفاده نمی‌شه
  // منطق ورود با کد توی Login.js پیاده‌سازی شده

  return (
    <div style={{ padding: "20px", textAlign: "center" }}>
      <p>این صفحه دیگر استفاده نمی‌شود.</p>
      <button onClick={() => navigate("/login")}>بازگشت به ورود</button>
    </div>
  );
}

export default GetCode;